import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { MethodOverview } from './components/MethodOverview';
import { MaterialPreview } from './components/MaterialPreview';
import { MoreTestimonials } from './components/MoreTestimonials';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Footer } from './components/Footer';
import { EmotionalClose } from './components/EmotionalClose';
const TransitionPhrase = () => <div className="max-w-3xl mx-auto px-6 py-12 md:py-20 text-center pt-[4px] pb-[4px]" data-id="element-0">
    <p className="text-xl md:text-3xl font-display italic text-brand-darkGreen/85 leading-relaxed font-[800]" data-id="element-1">
      🌿 EL PROBLEMA NO ES TU TERAPIA. EL PROBLEMA ES QUE NADIE LA CONOCE.
    </p>
  </div>;
export function App() {
  return <div className="min-h-screen text-brand-text font-sans selection:bg-brand-aqua/25 selection:text-brand-darkGreen bg-brand-surface" data-id="element-2">
      <UrgencyBanner data-id="element-3" />
      <Hero data-id="element-4" />
      <PainPoints data-id="element-5" />
      <MethodOverview data-id="element-6" />
      <MaterialPreview data-id="element-7" />
      <MoreTestimonials data-id="element-8" />
      <CostComparison data-id="element-9" />
      <TransitionPhrase data-id="element-10" />
      <EmotionalClose data-id="element-11" />
      <FAQ data-id="element-12" />
      <Guarantee data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}